/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Knowledge_UnknownInputs */

const en_directory_knowledge_unknown = /** @type {(inputs: Directory_Knowledge_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown`)
};

const zh_directory_knowledge_unknown = /** @type {(inputs: Directory_Knowledge_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未知`)
};

/**
* | output |
* | --- |
* | "Unknown" |
*
* @param {Directory_Knowledge_UnknownInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_knowledge_unknown = /** @type {((inputs?: Directory_Knowledge_UnknownInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Knowledge_UnknownInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_knowledge_unknown(inputs)
	return zh_directory_knowledge_unknown(inputs)
});
export { directory_knowledge_unknown as "directory.knowledge.unknown" }